import BaseRepository from "./BaseRepository";
import ProductPricingAPICall from "../service/ProductPricingAPICall";
import store from "../storeWire";
import { isObject } from "underscore";
import ProductPricing from "src/model/ProductPricing";
import { chunk } from "underscore";
import Helper from "src/support/Helper";

class ProductPricingRepository extends BaseRepository {

    fetchProductPricingByProductsNew = async (products, force_refresh = false, inventory = {}) => {
        if (!isObject(products)) {
            console.error('products should be Object anything else passed')
        }
        let pricing = {};
        if (products !== undefined && Object.entries(products).length > 0) {
            let params = [];
            let prod = Helper.removeDuplicateFromObjectByItemNumber(products)
            
            Object.entries(prod).map((v) => {
                let product = v[1]
                if (v[1].assets && v[1].assets.product) {
                    product = v[1].assets && v[1].assets.product
                }

                let paramData = {
                    partNumber: product?.ERPPartNumberModified ? '' : product.ERPPartNumber,
                    erpManufacturerCode: product.ERPManufacturerCode,
                    erpMfrPartNumber: product.ERPMFRPartNumber,
                    WebCode: product.WebCode,
                    ObsoleteFlag: product.ObsoleteFlag
                }
                if (product.selectedCurrency) {
                    paramData.currency = product.selectedCurrency
                }
                if (product.selectedCPN) {
                    paramData.customerPartNumber = product.selectedCPN
                }
                if (inventory[product.ERPPartNumber]?.qas) {
                    paramData.Qas = inventory[product.ERPPartNumber]?.qas
                }
                if (product.ItemNumber) {
                    paramData.ItemNumber = product.ItemNumber
                }
                if (product.itemNumber) {
                    paramData.ItemNumber = product.itemNumber
                }

                params.push(paramData)
            });

            if (params.length) {
                let paramSet = await new ProductPricingRepository().getPricingParams(params);
                pricing = await new ProductPricingAPICall().getPricingNew(paramSet)
                if (Object.entries(pricing) && Object.entries(pricing).length > 0) {
                    Object.entries(pricing).map((v, i) => {
                        let partPrice = []
                        /**
                         * Here partNumber = ERPPartNumber & manufacturerPartNumber = ERPMFRPartNumber
                         */
                        const _parent = {
                            "partNumber": v[1].partNumber,
                            "erpManufacturerCode": v[1].erpManufacturerCode,
                            "customerPartNumber": v[1].customerPartNumber,
                            "customerPartNumberOut": v[1].customerPartNumberOut,
                            "erpMfrPartNumber": v[1].erpMfrPartNumber,
                            "originalLine": v[1].originalLine,
                            "currency": v[1].currency,
                            "currIND": v[1].currIND,
                            "salesOrg": v[1].salesOrg,
                            "message": v[1].message,
                            "error": v[1].error
                        };

                        if (v[1] && v[1].prices && v[1].prices.length > 0) {
                            v[1].prices.map((p, j) => {
                                let _price = {
                                    ..._parent,
                                    ...p
                                }
                                partPrice.push(_price)
                            })
                        }
                        pricing[v[1].erpMfrPartNumber] = partPrice;
                    });
                }
            }
        }
        return pricing;
    };

    getPricingFromCartPriceBeforeSendToServerByERPPartNumber = async (ItemNumber) => {
        let state = store.getState();
        if (state.entities.Cart.CART_PRICE_BEFORE_TO_SEND_SERVER !== undefined &&
            state.entities.Cart.CART_PRICE_BEFORE_TO_SEND_SERVER[ItemNumber] !== undefined &&
            state.entities.Cart.CART_PRICE_BEFORE_TO_SEND_SERVER[ItemNumber].unitPrice !== undefined
        ) {
            return state.entities.Cart.CART_PRICE_BEFORE_TO_SEND_SERVER[ItemNumber].unitPrice;
        }
        return false;
    };

    async getPricingParams(params) {
        if (params.length) {
            params = params.map((params_single) => {
                return new ProductPricing().setParamsForServerCallNew(params_single)
            });

            let ar = chunk(params, params.length ? params.length : 20);

            let filterRes = ar && ar[0].filter(x => x.WebCode !== '4');
            filterRes = filterRes && filterRes.filter(x => !x.ObsoleteFlag || (x.ObsoleteFlag && x.Qas !== 0));
            filterRes = filterRes.map(({ WebCode, ObsoleteFlag, Qas, ItemNumber, ...item }) => item)

            return filterRes
        }
    };
}

export default ProductPricingRepository;